import { createRouter } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { routeTree } from "./routeTree.gen";
import { queryClient, registerRouter } from "./lib/queryClient";
import { RouteLoadError, logRouteError } from "./components/RouteLoadError";

export interface RouterContext {
  queryClient: QueryClient;
}

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPendingMs: 0,
  defaultPendingMinMs: 200,
  // Warm route code + loaders on hover/touch (links only) so navigation feels instant. Loader
  // data still defers to React Query's own staleness, so preload won't double-fetch fresh data.
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  // Contain a failed beforeLoad/loader (or a render error) to the route that failed, inside the
  // shell. Without this the router installs no catch boundary and the error reaches the RootApp
  // ErrorBoundary, replacing the whole app (2026-09-18 incident).
  defaultErrorComponent: RouteLoadError,
  defaultOnCatch: logRouteError,
});

// Wire the router into queryClient so its QueryCache/MutationCache onError
// handlers can redirect to /signin on SessionExpiredError (circular dep
// resolved via delayed registration — see ./lib/queryClient.ts).
registerRouter(router);

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
